import {
  SURVEY_SOURCING_LOAD_SOURCE,
  SURVEY_SOURCING_LOAD_TABLE_LOG,
  SURVEY_SOURCING_DETAIL,
  SURVEY_SOURCING_DELETE,
  SURVEY_SOURCING_ADD_NEW_LOCATION,
  SURVEY_SOURCING_EDIT_LOCATION,
  REMOVE_LISTS,
} from './actions'

const initialState = {
  // *load ข้อมูลต้นแหล่ง
  source_list: [],
  check_source_list: false,

  // *table log สำรวจต้นแหล่ง
  check_table_log: false,
  table_log_list: [],
  table_log_total: 0,

  // *detail สำรวจต้นแหล่ง
  lists_detail: [],
  check_detail: false,

  // *delete form
  check_delete: false,
  delete_response: null,

  // *add new location
  check_add_new_location: false,
  add_new_location_response: null,

  // *edit location
  check_edit_location: false,
  edit_location_response: null,
}
export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState
    case SURVEY_SOURCING_LOAD_SOURCE.REQUEST:
      return {
        ...state,
        source_list: [],
        check_source_list: true,
      }
    case SURVEY_SOURCING_LOAD_SOURCE.SUCCESS:
      return {
        ...state,
        source_list: action.payload.lists.origin_location || [],
        check_source_list: false,
      }

    case SURVEY_SOURCING_LOAD_TABLE_LOG.REQUEST:
      return {
        ...state,
        check_table_log: true,
      }
    case SURVEY_SOURCING_LOAD_TABLE_LOG.SUCCESS:
      return {
        ...state,
        check_table_log: false,
        table_log_list: action.payload.lists.data || [],
        table_log_total: action.payload.lists.total || 0,
      }
    case SURVEY_SOURCING_DETAIL.REQUEST:
      return {
        ...state,
        lists_detail: [],
        check_detail: true,
      }
    case SURVEY_SOURCING_DETAIL.SUCCESS:
      return {
        ...state,
        lists_detail: action.payload.lists,
        check_detail: false,
      }

    case SURVEY_SOURCING_DELETE.REQUEST:
      return {
        ...state,
        check_delete: true,
        delete_response: null,
      }
    case SURVEY_SOURCING_DELETE.SUCCESS:
      return {
        ...state,
        check_delete: false,
        delete_response: action.payload.lists,
      }
    case SURVEY_SOURCING_ADD_NEW_LOCATION.REQUEST:
      return {
        ...state,
        check_add_new_location: true,
        add_new_location_response: null,
      }
    case SURVEY_SOURCING_ADD_NEW_LOCATION.SUCCESS:
      return {
        ...state,
        check_add_new_location: false,
        add_new_location_response: action.payload.lists,
      }

    case SURVEY_SOURCING_EDIT_LOCATION.REQUEST:
      return {
        ...state,
        check_edit_location: true,
        edit_location_response: null,
      }
    case SURVEY_SOURCING_EDIT_LOCATION.SUCCESS:
      return {
        ...state,
        check_edit_location: false,
        edit_location_response: action.payload.lists,
      }

    default:
      return state
  }
}
